import { render, staticRenderFns } from "./CustomerFraudAudit.vue?vue&type=template&id=48a60d50&scoped=true"
import script from "./CustomerFraudAudit.vue?vue&type=script&lang=js"
export * from "./CustomerFraudAudit.vue?vue&type=script&lang=js"
import style0 from "./CustomerFraudAudit.vue?vue&type=style&index=0&id=48a60d50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a60d50",
  null
  
)

export default component.exports